import { reduxForm } from 'redux-form';
import Component from './Component';

const initialValues = {
  file: null,
  reason: '',
};

const FormNikActivatedSingle = reduxForm({
  form: 'FormNikActivatedSingle',
  initialValues,
  enableReinitialize: true,
})(Component);

export default FormNikActivatedSingle;
